<template>
  <div id="printReport">
    <div class="row">
      <div class="col-md-2">
        <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
      </div>
      <div class="col-md-8">
        <h3 class="text-center">Relatório de Conversão de Mídia</h3>
      </div>
      <div class="col-md-2"></div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-defaul">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <label>Loja:</label>
                  </div>
                  <div class="col-md-4">
                    <label for>Data Referência:</label>
                  </div>
                  <div class="col-md-4">
                    <label for>Gerador Por:</label>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">{{ !form.branche_id ? 'TODAS' : store_branch}}</div>
                  <div class="col-md-4">{{ !form.reference ? 'TODAS' : date_reference }}</div>
                  <div class="col-md-4">{{ user_auth_name }}</div>
                </div>

                <div class="row">
                  <div class="col-sm-12">&nbsp;</div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <label>Administradora</label>
                  </div>
                  <div class="col-md-4">
                    <label>Período</label>
                  </div>
                  <div class="col-md-4">
                    <label>Criado em</label>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">{{ !administrator_id_ ? 'TODAS' : administrator }}</div>
                  <div
                    class="col-md-4"
                  >{{ init_at | moment('DD/MM/YYYY') }} à {{ end_at | moment('DD/MM/YYYY') }}</div>
                  <div
                    class="col-md-4"
                  >{{ new Date() | moment('DD/MM/YYYY') }} às {{ new Date() | moment('H[:]mm[h]')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <table class="table b-table table-sm" id="tabela">
          <thead class="thead-dark">
            <tr>
              <th>Vendedor</th>
              <th
                class="text-center"
                v-for="(iterator, key) of medias"
                :key="key"
                colspan="3"
              >{{iterator.name}}</th>
              <th class="text-center" colspan="3">Total</th>
            </tr>
            <tr>
              <th></th>
              <template v-for="(iterator, key) of medias">
                <th class="text-center">Cotas</th>
                <th class="text-center">%</th>
                <th class="text-center">Valor</th>
              </template>
              <th class="text-center">Cotas</th>
              <th class="text-center">%</th>
              <th class="text-center">Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-center" v-for="(iterator, key) of sellers" :key="key">
              <td>{{iterator.name}}</td>
              <template class="text-center" v-for="(iteratorM, key) of medias">
                <td class="text-center">{{iterator.medias[iteratorM.id].proposals}}</td>
                <td
                  class="text-center"
                >{{ (((iterator.medias[iteratorM.id].proposals || 0) / (iterator.proposals || 1)) * 100).toFixed(2)}}%</td>
                <td class="text-center">R$ {{iterator.medias[iteratorM.id].value | price}}</td>
              </template>
              <td class="text-center">{{iterator.proposals}}</td>
              <td class="text-center">100%</td>
              <td class="text-center">R$ {{iterator.value | price}}</td>
            </tr>
            <tr>
              <td class="text-right" style="background-color:#ccc;color: darkgreen">
                <b>Total</b>
              </td>
              <template class="text-center" v-for="(iteratorM, key) of medias">
                <td
                  class="text-center"
                  style="background-color:#ccc;color: darkgreen"
                >{{total[iteratorM.id].proposals}}</td>
                <td
                  class="text-center"
                  style="background-color:#ccc;color: darkgreen"
                >{{(Math.round(((total[iteratorM.id].proposals || 0) / (proposals || 1)) * 100)).toFixed(2)}}%</td>
                <td
                  class="text-center"
                  style="background-color:#ccc;color: darkgreen"
                >R$ {{total[iteratorM.id].value | price}}</td>
              </template>
              <td class="text-center" style="background-color:#ccc;color: darkgreen">{{proposals}}</td>
              <td class="text-center" style="background-color:#ccc;color: darkgreen">100%</td>
              <td
                class="text-center"
                style="background-color:#ccc;color: darkgreen"
              >R$ {{value | price}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row dont-print">
      <div class="col-md-12 text-center">
        <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
        <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
        <!--button-- type="button" @click="excel()" class="btn btn-fill btn-success">Excel</!--button-->
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  components: {},
  computed: {
    user_auth_name() {
      return this.$store.state.auth.user.name.toUpperCase();
    },
    branches() {
      return this.$store.state.defaults.branches;
    },
    dates: {
      get() {
        var dates = [
          { id: "sale_date", name: "Data da Venda" },
          { id: "due_date", name: "Data de Vencimento" },
          { id: "payday", name: "Data de Pagamento" }
        ];

        return dates;
      }
    }
  },
  data() {
    return {
      moment: Vue.moment,
      report: [],
      administrator_id_: null,
      detail: [],
      date: null,
      end_at: null,
      form: {},
      init_at: null,
      medias: [],
      sellers: [],
      total: {},
      proposals: 0,
      value: 0
    };
  },
  methods: {
    close() {
      window.opener.focus();
      window.close();
    },
    async getData() {
      var self = this;

      self.$root.$emit("onLoading");
      const response = self.$store.dispatch(
        "reports/mediaConversion",
        self.form
      );

      response.then(function(res) {
        self.medias = res.medias;

        for (const media of self.medias) {
          self.total[media.id] = { proposals: 0, value: 0 };
        }

        self.sellers = Object.values(res.selers);

        for (const seller of self.sellers) {
          for (const i in seller.medias) {
            const media = seller.medias[i];
            self.total[i].proposals += media.proposals;
            self.total[i].value += media.value;
            self.value += media.value;
            self.proposals += media.proposals;
          }
        }

        self.$root.$emit("onLoading");
        console.log("self.total", self.total);
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
    print() {
      window.print();
    },
    excel() {
      var nome = "Relatório de Conversão de Mídia";
      var htmlPlanilha =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
        nome +
        "</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><title>" +
        nome +
        "</title></head><body><table>" +
        document.getElementById("tabela").innerHTML +
        "</table>";
      var htmlBase64 = btoa(htmlPlanilha);
      var link = "data:application/vnd.ms-excel;base64," + htmlBase64;
      var hyperlink = document.createElement("a");
      hyperlink.download = "Relatório de Conversão de Mídia";
      hyperlink.href = link;
      hyperlink.style.display = "none";
      document.body.appendChild(hyperlink);
      hyperlink.click();
      document.body.removeChild(hyperlink);
    }
  },
  mounted() {
    var self = this;

    self.form = JSON.parse(self.$route.query.form);
    self.store_branch = self.form.branche_id
      ? self.branches
          .find(item => item.id === self.form.branche_id)
          .name.toUpperCase()
      : null;
    self.date_reference = self.form.reference
      ? self.dates
          .find(item => item.id === self.form.reference)
          .name.toUpperCase()
      : null;
    self.administrator_id_ = self.form.administrator_id;
    self.getData();

    // self.date = self.dates.find(date => date.id === self.form.date_by).name;
    self.init_at = self.form.date_at[0];
    self.end_at = self.form.date_at[1];
  }
};
</script>
<style type="scss">
body {
  overflow: auto;
}
@media print {
  @page{
    size: landscape;
    margin: 0;
    overflow: hidden;
  }
  .dont-print {
    display: none;
  }
  .table .thead-dark th {
    color: #aaaaaa;
  }
}
</style>

<style scoped>
</style>
